/// <amd-module name="VSS/Features/MarkdownEditor/Components/MarkdownPreview" />
import { IObservableValue, ObservableLike } from "VSS/Core/Observable";
import { TimerManagement } from "VSS/Core/TimerManagement";
import { MarkdownRendererComponent } from "VSS/Features/Markdown/MarkdownRendererComponent";
import { css } from "VSSUI/Util";
import * as React from "react";
import { IMarkdownPreviewProps } from "./MarkdownPreview.Props";

export const MarkdownPreview = (props: IMarkdownPreviewProps): JSX.Element | null => {
    const { className, linkClickHandler, onInitialRender, options, refreshThrottleMs, value } = props;

    const [content, setContent] = React.useState(props.setContentOnInitialRender ? value : "");
    const timerManagement = new TimerManagement();
    const setContentThrottled = refreshThrottleMs
        ? React.useCallback(timerManagement.throttle(setContent, refreshThrottleMs, { trailing: true }), [])
        : setContent;

    React.useEffect(() => {
        if (ObservableLike.isObservable(value)) {
            (value as IObservableValue<string>).subscribe(setContentThrottled);
            setContent((value as IObservableValue<string>).value);
        } else {
            setContentThrottled(value);
        }

        return () => {
            if (ObservableLike.isObservable(value)) {
                (value as IObservableValue<string>).unsubscribe(setContentThrottled);
            }
        };
    }, [value]);

    return content ? (
        <MarkdownRendererComponent
            className={css("markdown-editor-preview", className)}
            linkClickHandler={linkClickHandler}
            onInitialRender={onInitialRender}
            rawContent={content.trim()}
            options={options}
            aria-label={props.ariaLabel}
        />
    ) : null;
};
